import { render, staticRenderFns } from "./SapMatnrList.vue?vue&type=template&id=6321712c"
import script from "./SapMatnrList.vue?vue&type=script&lang=js"
export * from "./SapMatnrList.vue?vue&type=script&lang=js"
import style0 from "./SapMatnrList.vue?vue&type=style&index=0&id=6321712c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports